export default __webpack_public_path__ + "static/fonts/Anko-Regular.73d67d0.woff";